export default {"src":"/_next/static/media/google.5ee5de43.svg","height":720,"width":706,"blurWidth":0,"blurHeight":0};